import { render, staticRenderFns } from "./ProfitChart.vue?vue&type=template&id=79141fb6&scoped=true&"
import script from "./ProfitChart.vue?vue&type=script&lang=ts&"
export * from "./ProfitChart.vue?vue&type=script&lang=ts&"
import style0 from "./ProfitChart.vue?vue&type=style&index=0&id=79141fb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79141fb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79141fb6')) {
      api.createRecord('79141fb6', component.options)
    } else {
      api.reload('79141fb6', component.options)
    }
    module.hot.accept("./ProfitChart.vue?vue&type=template&id=79141fb6&scoped=true&", function () {
      api.rerender('79141fb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/chart/ProfitChart.vue"
export default component.exports